import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import Modal from "../common/Modal";
import AutomatedShare from ".";
import { useTranslation } from "react-i18next";
import Toast from "../Toast";
import { useEffect } from "react";

const AutomatedShareModal = () => {
  const { t } = useTranslation();
  const { isVisible } = useStoreState(Store, (s) => ({
    isVisible: s.isAutomatedSharingOpen,
  }));

  const onCloseModal = () => {
    Store.update((s) => {
      s.isAutomatedSharingOpen = false;
    });
  };

  useEffect(() => {
    if (isVisible) {
      Toast.success("To Be Released in Future Updates")
    }
  }, [isVisible])

  return (
    <Modal
      title={t("automated_share.title")}
      onClose={onCloseModal}
      show={isVisible}
      className="flex flex-col w-full sm:w-7/12 lg:w-6/12 xl:w-4/12 h-auto !max-h-[90%] overflow-hidden"
    >
      <div className="relative h-full w-full blur-sm">
        {/* Disabled for PDS */}
        <div className="absolute top-0 left-0 h-full w-full z-[999] flex items-center justify-center">
        </div>

        <AutomatedShare isModal isVisible={isVisible} onClose={onCloseModal} />
      </div>
    </Modal>
  );
};

export default AutomatedShareModal;
